export const deviceFilterOptions = [
  "all",
  "win-non-vr",
  "win-vr",
  "quest",
  "wave",
  "pico",
  "magic-leap",
] as const;

export type DeviceFilterOption = (typeof deviceFilterOptions)[number];

export const renderModeFilterOptions = ["all", "streaming", "local"] as const;

export type RenderModeFilterOption = (typeof renderModeFilterOptions)[number];

// which listing the home page shows: admin-defined categories or a flat list of all apps
export const applicationViewOptions = ["categories", "all"] as const;

export type ApplicationViewOption = (typeof applicationViewOptions)[number];
